import { toast } from "react-toastify";
import { authAxios } from "../api/config";
import { _baseURL } from "../api/config";
// const API_URL = "https://localhost:44374/api";
export const API_URL = process.env.REACT_APP_CHATBOT_CHAT_SAVE_API_URL;
// export const API_URL = "https://localhost:7226/api";
export const FAST_API_URL = process.env.REACT_APP_PYTHON_FAST_API_URL;

// ---- Documents ----
export const getAllDocuments = async () => {
  try {
    const res = await authAxios.get(`${API_URL}/UploadDocument/GetAllDocuments`);
    return res.data;
  } catch (err) {
    console.error("Error fetching documents:", err);
    return err.response?.data || { error: err.message };
  }
};

export const getAllDeletedDocuments = async () => {
  try {
    const res = await authAxios.get(`${API_URL}/UploadDocument/GetAllDeletedDocuments`);
    return res.data;
  } catch (err) {
    console.error("Error fetching deleted documents:", err);
    return err.response?.data || { error: err.message };
  }
};

export const restoreDeletedDocumentSql = async (qdrantDocId) => {
  try {
    const res = await authAxios.post(`${API_URL}/UploadDocument/RestoreDocument`, {
      qdrantDocId,
    });
    return res.data;
  } catch (err) {
    console.error("Error restoring document:", err);
    return err.response?.data || { error: err.message };
  }
};

export const getChunksByDocument = async (qdrantDocId) => {
  try {
    const res = await authAxios.post(`${API_URL}/UploadDocument/GetChunksByDocument`, {
      qdrantDocId,
    });
    return res.data;
  } catch (err) {
    console.error("Error fetching document chunks:", err);
    return err.response?.data || { error: err.message };
  }
};


// ---- Collections ----
export const getUsers = async (req) => {
  try {
    const res = await authAxios.post(
      `${API_URL}/GuestUser/GetPaginatedUsers`,
      req
    );
    return res.data;
  } catch (err) {
    console.error("Error fetching users:", err);
    return err.response?.data || { error: err.message };
  }
};
// ---- getFilteredPaginatedConnections ----
export const GetUserAgentConnections = async (req) => {
  try {
    const res = await authAxios.post(
      `${API_URL}/Chat/getFilteredPaginatedConnections`,
      req
    );
    return res.data;
  } catch (err) {
    console.error("Error fetching users:", err);
    return err.response?.data || { error: err.message };
  }
};

export const getUserBotChatDates = async (userId) => {
  try {
    const res = await authAxios.post(
      `${API_URL}/Chat/GetUserBotChatUniqueDates`,
      {
        userID: userId,
      }
    );
    return res.data;
  } catch (err) {
    console.error("Error fetching chat dates:", err);
    return err.response?.data || { error: err.message };
  }
};

export const getUserBotChats = async (userId, chatDate) => {
  try {
    const res = await authAxios.post(`${API_URL}/Chat/GetUserBotChatsByDate`, {
      user_Id: userId,
      chat_Date: chatDate,
    });
    return res.data;
  } catch (err) {
    console.error("Error fetching chats:", err);
    return err.response?.data || { error: err.message };
  }
};

// ---- GetDashboardCountSql ----
export const GetDashboardCountSql = async () => {
  try {
    const res = await authAxios.get(`${API_URL}/Chat/getDashboardStats`);
    console.log("here is the res of GetDashboardCountSql " , res)
    return res.data;
  } catch (err) {
    console.log("errror of getdashboardstatics",err)
    return err.response?.data || { error: err.message };
  }
};

// ---- GetRecentConnection ----
export const GetRecentConnection = async () => {
  try {
    const res = await authAxios.get(`${API_URL}/Chat/GetRecentConnections`);
    console.log("here is the res of connection data " , res)
    return res.data;
  } catch (err) {
    console.log("here is the error of connection",err)
    return err.response?.data || { error: err.message };
  }
};

// ---- GetUserAgentChats ----
export const GetUserAgentChats = async (req) => {
  try {
    const res = await authAxios.post(`${API_URL}/Chat/GetUserAgentChats`, req);
    return res.data;
  } catch (err) {
    console.error("Error fetching users:", err);
    return err.response?.data || { error: err.message };
  }
};

// ---- GetUnansweredQuestion ----
export const GetUnansweredQuestion = async (req) => {
  try {
    const res = await authAxios.post(
      `${API_URL}/Chat/getUnansweredQuestionByConnId`,
      req
    );
    return res.data;
  } catch (err) {
    console.error("Error fetching users:", err);
    return err.response?.data || { error: err.message };
  }
};

// ---- UpdateChatConnectionsIsSaved ----
export const UpdateChatConnectionsIsSaved = async (req) => {
  try {
    const res = await authAxios.post(
      `${API_URL}/Chat/UpdateChatConnectionsIsSaved`,
      req
    );
    return res.data;
  } catch (err) {
    console.error("Error fetching users:", err);
    return err.response?.data || { error: err.message };
  }
};

export const AnswerUnansweredQuestion = async (req) => {
  try {
    const res = await authAxios.post(
      `${API_URL}/Chat/InsertAnswerToUnansweredQuestion`,
      req
    );
    return res.data;
  } catch (err) {
    console.error("Error fetching users:", err);
    return err.response?.data || { error: err.message };
  }
};

// ---- GetUsersSessionByEmail ----
export const GetUsersSessionByEmail = async (req) => {
  try {
    const data = {
      uniqueIdentity: req,
    };
    const res = await authAxios.post(
      `${API_URL}/GuestUser/GetUsersSessionByEmail`,
      data
    );
    return res.data;
  } catch (err) {
    console.error("Error fetching users:", err);
    return err.response?.data || { error: err.message };
  }
};
